import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import SvgContestCalendar from '@/assets/icons/contest-calendar.svg';
import {
    clampContestMonth,
    getContestMonthOptions,
} from '@/components_v3/affiliate/contest/shared/config/contest-months';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestMonthPicker',
  props: {
    value: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:value"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:value', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, disabled: boolean }





const menu = ref(false);
const monthOptions = getContestMonthOptions();

const displayLabel = computed(() => {
    const option = monthOptions.find((item) => item.value === props.value);

    return option?.text ?? props.value;
});

function selectMonth(month: string): void {
    if (props.disabled) {
        return;
    }

    emit('update:value', clampContestMonth(month));
    menu.value = false;
}

return { __sfc: true,props, emit, menu, monthOptions, displayLabel, selectMonth, SvgContestCalendar }
}

})